export enum AccountType {
  User = 'user',
  Business = 'business'
}
